module.exports = __webpack_public_path__ + "img/Ja.cc843333.png";